import { gql } from '@apollo/client';

export const FETCH_MODEL_PORTFOLIO_CHILDREN_QUERY = `query fetchModelPortfolioChildren($input: FetchModelPortfolioChildrenInput!) {
  fetchModelPortfolioChildren(input: $input) {
    children {
      id
      percentage
      effectivePercentage
      financialProduct {
        id
        name
        isCash
        ticker
        primaryAssetClass {
          id
          name
        }
        taxRank
        secondaryAssetClass {
          id
          name
        }
      }
      taxRank
      isCashEquivalent
    }
    totalCount
  }
}`;

export const FETCH_MODEL_PORTFOLIO_CHILDREN = gql`${FETCH_MODEL_PORTFOLIO_CHILDREN_QUERY}`;
